import { useAuth0 } from "@auth0/auth0-react";
import Grid from "@mui/material/Grid";
import { ReactComponent as ArrowDown } from "assets/icons/ArrowDown.svg";
import { ReactComponent as ArrowTop } from "assets/icons/ArrowTop.svg";
import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
import { InputField } from "components/InputField/InputField";
import { MultiSelect } from "components/MultiSelect/MultiSelect";
import InfoTooltip from "components/InfoTooltip";
import { useSearch } from "hook";
import CommunicationService from "Lib/API/Communication/index";
import { debounce } from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import Select, { components } from "react-select";
import { setSelectedTemplate } from "services/api/communication";
import { Footer } from "../Footer/Footer";
import {
  ArrowButton,
  AudienceType,
  ButtonItem,
  CampaignSectionWrapper,
  EventType,
  FooterWrapepr,
  Input,
  InputWrapper,
  Title,
  TreggarButtons,
  Wrapper,
  WrapperButtons,
} from "./Theme";
export const CreateAutomationForm = ({
  formik,
  onNext,
  onBack,
  buttonsProps,
  children,
  dropDownType
}) => {
  const dispatch = useDispatch();
  const { getAccessTokenSilently } = useAuth0();
  const [types, setTypes] = useState([]);
  const dateTypes = ["Day", "Month", "Year"];
  const [show, setShow] = useState(formik.values?.timeExecute?.timeType);
  const [showDate, setShowDate] = useState(formik.values?.timeExecute?.timePeriod);
  const [value, setValue] = useState(1);
  const [audienceList, setAudienceList] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const { searchAction } = useSearch({ action: setSearch });
  const { automationEditData,selectedTemplate } = useSelector((state) => state.communication);
  
  const AccountFilterItems = [
    {
      name: "Apply to Audience Groups",
      isOptinal: false,
      data: audienceList,
      loading: loading,
      formikField: `account.audiences`,
      variableForSave: "_id",
      formikKey: "audiences",
      total: count,
    },
  ];

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <BottomArrowSvg label="Emoji" />
      </components.DropdownIndicator>
    );
  };
  const increment = () => {
    setValue(value + 1);
    formik.setFieldValue("timeExecute.unit", Number(value + 1));
  };
  const decrement = () => {
    if (value - 1 > 0) {
      setValue(value - 1);
      formik.setFieldValue("timeExecute.unit", Number(value - 1));
    }
  };
  const formatOptionLabel = ({ label, _id }) => {
    return (
      <div className="dropdown-container" key={_id}>
        <div className="icon-name-container d-flex align-items-center justify-content-start">
          <div className="name-container" style={{ marginInlineStart: 10 }}>
            <div>{label}</div>
          </div>
        </div>
      </div>
    );
  };

  const selectStyles = {
    control: (styles) => ({
      ...styles,
      ...selectControlStyles,
    }),
    menuList: (styles) => ({
      ...styles,
      maxHeight: "200px",
    }),
  };

  const selectControlStyles = {
    backgroundColor: "transparent",
    borderColor: "#E1E1E7",
    color: "#b5b5c3",
    transition:
      "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
    paddingTop: "6px",
    paddingBottom: "6px",
    cursor: "pointer",
    width: "312px",
    height: "48px",
  };
  const buttons = buttonsProps
    ? buttonsProps
    : [
        {
          name: "Previous",
          action: () => {
            onBack();
          },
          isDisabled: false,
          type: "secondary",
          width: "100px",
          marginRight: "50rem",
          variant : "primary-outline"
        },
        {
          name: "Next",
          action: () => {
            onNext();
          },
          isDisabled:
            !formik.values?.automationName ||
            !formik?.values?.eventType ||
            formik?.values?.account?.audiences?.length === 0 ||
            !formik.values?.timeExecute?.timeType,
          type: "primary",
          width: "100px",
          variant : "primary"
        },
      ];

  const getAudinceList = async () => {
    setLoading(true);
    let data;
    if (search) {
      data = {
        search: search.value,
      };
    }

    try {
      const token = await getAccessTokenSilently();
      const result = await CommunicationService.getAudienceList(
        token,
        1,
        10,
        data
      );
      setCount(result?.payload?.pagination?.count);
      const resultData = result?.payload?.data?.map((item) => {
        return {
          title: item.name,
          id: item._id,
          ...item,
        };
      });
      setAudienceList(resultData);
    } catch (err) {
      toastr.error("Error", err?.data?.message);
    } finally {
      setLoading(false);
    }
  };
  const handleInputChange = (e) => {
    const value = e.target.value;
    if (value < 0 || value === 0 || !value) {
    } else {
      setValue(Number(value));
      formik.setFieldValue("timeExecute.unit", Number(value));
    }
  };
  const debounceSearch = useCallback(
    debounce(() => {
      if (search) {
        getAudinceList();
      }
    }, 500),
    [search]
  );

  useEffect(() => {
    if (search) {
      debounceSearch();
    } else {
      getAudinceList();
    }
    return () => debounceSearch.cancel();
  }, [search]);

  const handleFormikChange = (items, formikField) => {
    formik.setFieldValue(formikField, items);
  };


  console.log("timeExecute", formik.values?.timeExecute?.timeType);
  useEffect(() => {
    let list = ["Before", "On The Day", "After"];
    if (!formik.values?.eventType?.value) return;
    switch(formik.values?.eventType?.label) {
      case "Date of birth":
      case "Date of death":
      case "Join date":
        list = ["On The Day", "After"];
        formik.setFieldValue("timeExecute.timeType", "on the day");
        setShow("On The Day");
        break;
      case "Next birthday":
      case "Next Yahrzeit":
        list = ["Before", "On The Day"];  
        formik.setFieldValue("timeExecute.timeType", "before");
        setShow("Before");
        break;
      default:
        formik.setFieldValue("timeExecute.timeType", "before");
        setShow("Before");
        break;
    }
    setTypes(list);
  }, [formik.values?.eventType]);

  return (
    <Wrapper>
      <Title>{Object.keys(automationEditData).length >0 ? "":"Create Automation"}</Title>
      <>
        <CampaignSectionWrapper>
          <InputField
            mandatory
            label={`Automation Name`}
            type="text"
            formik={formik}
            value={formik.values?.automationName}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
              }
            }}
            style={{
              width: "312px",
              height: "48px",
            }}
            styleWrapper={{
              display: "flex",
              flexDirection: "column",
              paddingLeft: "1px",
              justifyContent: "center",
            }}
            Wrapper={{ alignItems: "baseline" }}
            labelStyle={{
              color: "#002E5C",
              fontSize: "14px",
              fontWeight: 400,
            }}
            onChange={(e) => {
              formik.setFieldValue("automationName", e.target.value);
            }}
          />
        </CampaignSectionWrapper>
        <br />
        <EventType>
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <label
              style={{
                color: "rgb(0, 46, 92)",
                fontWeight: 400,
                fontSize: "14px",
                paddingTop: "5px",
              }}
            >
              Event Type
              <label style={{ fontWeight: "500", color: "red" }}>{" *"}</label>
            </label>
            <InfoTooltip text="The trigger that starts this automation, e.g. Date of birth, Date of death, Join date, Next birthday, or Next Yahrzeit. This choice determines which Timing options are available below." style={{ marginLeft: '6px', marginTop: '-5px' }} />
          </div>
          <Select
            menuPosition={"fixed"}
            classNamePrefix="react-select"
            formatOptionLabel={formatOptionLabel}
            placeholder="Select a Module"
            options={dropDownType}
            styles={selectStyles}
            onChange={(value) => {
              formik.setFieldValue("eventType", value);
              formik.setFieldValue("account.audiences", undefined);
              if (selectedTemplate?._id ) {
                dispatch(setSelectedTemplate({}));
              }
            }}
            value={formik?.values?.eventType}
            components={{ DropdownIndicator }}
          />
        </EventType>
        <br />
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <label
            style={{
              color: "rgb(0, 46, 92)",
              fontWeight: 400,
              fontSize: "14px",
              paddingTop: "5px",
            }}
          >
            Timing
            <label style={{ fontWeight: "500", color: "red" }}>{" *"}</label>
          </label>
          <InfoTooltip text="When this automation runs relative to the Event Type. Available options change based on the event: e.g. Before / On The Day for a birthday, or On The Day / After for a join date. If you pick Before or After, set how many Days, Months, or Years too — e.g. 3 Days Before." style={{ marginLeft: '6px', marginTop: '-6px' }} />
        </div>
        <WrapperButtons>
          <>
          {types?.length > 0 && (
            <TreggarButtons>
              {types?.map((type, idx) => (
                <ButtonItem
                  clicked={type?.toLowerCase() === show?.toLowerCase()}
                  key={idx}
                  onClick={() => {
                    setShow(type);
                    formik.setFieldValue(
                      "timeExecute.timeType",
                      type?.toLowerCase()
                    );
                  }}
                  {...{
                    formik,
                    name: `timeType`,
                    value: formik.values?.timeExecute?.timeType,
                  }}
                >
                  {type}
                </ButtonItem>
              ))}
            </TreggarButtons>
          )}
          </>
          {formik.values?.timeExecute?.timeType !== "on the day" 
          && formik.values?.timeExecute?.timeType !== "On The Day" && (
            <>
              <InputWrapper>
                <Input
                  type="number"
                  value={formik.values?.timeExecute?.unit}
                  onChange={(e) => {
                    handleInputChange(e);
                  }}
                  min="1"
                />
                <ArrowButton onClick={increment}>
                  <ArrowTop />
                </ArrowButton>
                <ArrowButton onClick={decrement}>
                  <ArrowDown />
                </ArrowButton>
              </InputWrapper>
              <>
                <TreggarButtons>
                  {dateTypes?.map((type, idx) => (
                    <ButtonItem
                      clicked={type?.toLowerCase() === showDate?.toLowerCase()}
                      key={idx}
                      onClick={() => {
                        setShowDate(type);
                        formik.setFieldValue(
                          "timeExecute.timePeriod",
                          type?.toLowerCase()
                        );
                      }}
                      {...{
                        formik,
                        name: `timePeriod`,
                        value: formik.values?.timeExecute?.timePeriod,
                      }}
                    >
                      {type}
                    </ButtonItem>
                  ))}
                </TreggarButtons>
              </>
            </>
          )}
        </WrapperButtons>
        <br />
        <AudienceType>
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <label
              style={{
                color: "rgb(0, 46, 92)",
                fontWeight: 400,
                fontSize: "14px",
                paddingTop: "5px",
              }}
            >
              Apply to Audience Groups
              <label style={{ fontWeight: "500", color: "red" }}>{" *"}</label>
            </label>
            <InfoTooltip text="Pick which audience(s), created in the Audiences tab, this automation sends to. Only members in the selected group(s) will receive it." style={{ marginLeft: '6px', marginTop: '-4px' }} />
          </div>
          <Grid container columns={{ xs: 4, sm: 8, md: 12 }}>
            {AccountFilterItems?.map((val) => (
              <Grid item xs={2} sm={2} md={3} key={val.name}>
                <MultiSelect
                  placeholder="Select"
                  isOptinal={val.isOptinal}
                  isCheckBoxOption={true}
                  options={val?.data}
                  loading={val?.loading}
                  formikField={val.formikField}
                  setOptions={setAudienceList}
                  variableForSave={val?.variableForSave}
                  formik={formik}
                  handleFormikChange={handleFormikChange}
                  isAccount={true}
                  formikKey={val.formikKey}
                  searchAction={searchAction}
                  total={val.total}
                  isMultiple={true}
                  isAll={automationEditData?.allAudiences}
                />
              </Grid>
            ))}
          </Grid>
        </AudienceType>
        <br />
        {children}
      </>

      <FooterWrapepr bottom={buttonsProps}>
        <Footer
          buttons={buttons}
          type="My template"
          Wrapperstyle={{ width: "88%" }}
        />
      </FooterWrapepr>
    </Wrapper>
  );
};
